import React, { Component } from 'react'
import { connect } from 'react-redux';


class IngredientRow extends Component {
  convertOunces(cl) {
    let oz;
    if (cl == 0.75) {
      return String.fromCharCode(188) + ' fl oz'; // &frac14;
    } else if (cl == 0.5) {
      return '1 teaspoon';
    } else if (cl < 1) {
      let ct = cl * 10;
      let measure = "";
      if (ct > 1) {
        measure = " dashes";
      } else {
        measure = " dash";
      }
      return ct + measure;
    } else {
      oz = Math.round((cl * 0.33814) * 2) / 2
      if (oz == 0.5) {
        return String.fromCharCode(189) + ' fl oz'; // &frac12;
      } else {
        return oz + ' fl oz';
      }
    }
  }
  
  render() {
    const {meas_index, machine_name, selected_measurements, ingredients} = this.props;

    let colSpan = 1;
    let usUnits;
    if (selected_measurements[meas_index] < 1 && selected_measurements[meas_index] != 0.5 && selected_measurements[meas_index] != 0.75) {
      colSpan = 2;
    } else {
      usUnits = (
        <td>{selected_measurements[meas_index]} cl</td>
      )
    }

    // BEGIN
    const isIngredient = p => p.machine_name === machine_name
    const ingredient = ingredients.items.find(isIngredient)
    // END

    return <tr key={meas_index}><td colSpan={colSpan}>{this.convertOunces(selected_measurements[meas_index])}</td>{usUnits}<td>{ingredient.name}</td></tr>
  }
}



const connectedIngredientRow = connect(null)(IngredientRow);
export { connectedIngredientRow as IngredientRow };


// WEBPACK FOOTER //
// ./src/IngredientRow/IngredientRow.jsx